module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [(_vm.inbehandeling == 'J') ? _c('div', {
    staticClass: "alert alert-success"
  }, [_vm._v("\n\t\tDeze polis is in behandeling.\n\t")]) : _vm._e(), _vm._v(" "), (_vm.opgeschort == 'J') ? _c('div', {
    staticClass: "alert alert-success"
  }, [_vm._v("\n\t\tDeze polis is tijdelijk stopgezet.\n\t")]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-169bc340"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/frontend/components/polisdetails/inbehandeling.vue
// module id = 59
// module chunks = 0